// Cart Module
// Licensed under Apache 2 (http://www.apache.org/licenses/LICENSE-2.0)
// DO NOT MODIFY
Wee.fn.make('cart', {
	init: function() {
		var priv = this.$private;

		priv.createCart();
		priv.renderQuoteList();
		priv.initEvents();
		priv.updateCart();
		priv.showEmptyCart();

		// Rerender app on screensize
		Wee.screen.map({
			callback: _.throttle(priv.reRenderApp.bind(priv), 500, {
				'trailing': true
			})
		});
	},

	unload: function() {
		$.events.off(false, '.cart');
	}
}, {
	/**
	 * Create cart on page load
	 *
	 * @private
	 */
	createCart: function() {
		this.store = Wee.fn.storage();

		var itemCount = this.store.get('itemCount');

		if (this.store.get('items') === null) {
			this.store.set('items', []);
			this.store.set('itemCount', 0);
		}

		$('ref:quoteCartNumber').text(itemCount + (itemCount === 1 ? ' item' : ' items'));
	},

	reRenderApp: function() {
		this.app.$resume(true);
	},

	/**
	 * Init events
	 *
	 * @private
	 */
	initEvents: function() {
		var scope = this;

		Wee.events.on({
			'ref:optionsSubmit': {
				click: function(e, el) {
					scope.addToCart($(el).closest('ref:optionsForm').serialize(true));

					e.preventDefault();
				}
			},
			'ref:changeProductQuantity': {
				click: function() {
					var count = 1;

					if ($(this).data('down') !== null) {
						if (count === 1) {
							return;
						}
						count--;
					} else {
						count++;
					}
				}
			},
			'ref:changeCartQuantity': {
				click: function() {
					var $this = $(this),
						app = scope.app,
						index = $this.parents('ref:item').data('index'),
						count = app.$get('items.' + index + '.quantity'),
						productPrice = parseFloat(app.$get('items.' + index + '.productPrice').slice(1)).toFixed(2);

					if ($this.data('down') !== null) {
						if (count === 1) {
							return;
						}
						count--;
					} else {
						count++;
					}

					scope.syncItems('items.' + index + '.quantity', count);
					scope.syncItems('items.' + index + '.totalPrice', (count * productPrice).toFixed(2));
					app.$set('total', scope.getTotalPrice());
				}
			},
			'ref:removeItem': {
				click: function(e, el) {
					scope.removeItem(el);
				}
			}
		}, {
			namespace: 'cart'
		});
	},

	/**
	 * Add items to cart
	 *
	 * @private
	 */
	addToCart: function(item) {
		var scope = this,
			items = this.store.get('items');

		items.push(item);
		this.store.set('items', items);
		scope.updateItemCount();
	},

	/**
	 * Update cart item count
	 *
	 * @private
	 */
	updateItemCount: function() {
		var scope = this,
			itemCount = this.store.get('itemCount'),
			newCount = itemCount + 1;

		this.store.set('itemCount', newCount);
		scope.updateCart();
	},

	/**
	 * Update cart with number of items
	 *
	 * @private
	 */
	updateCart: function() {
		var itemCount = this.store.get('itemCount'),
			$qty = $('ref:cartQty');

		itemCount === 0 ? $qty.disable() : $qty.enable().text(itemCount);
	},

	/**
	 *	Render list of products in quote
	 *
	 * @private
	 */
	renderQuoteList: function() {
		this.app = Wee.app.make('quote-list', {
			target: 'ref:quoteItems',
			view: 'quote-list',
			model: this.createDataModel()
		});

		Wee.view.addHelper('capitalize', function() {
			return this.val.charAt(0).toUpperCase() + this.val.slice(1);
		});

		Wee.view.addHelper('conditionalHeader', function() {
			var size = Wee.screen.size();

			return size >= 3 && this.index !== 0;
		});
	},

	/**
	 * Create data model for Wee app
	 *
	 * @private
	 */
	createDataModel: function() {
		var items = this.store.get('items'),
			total = 0;

		for (var i = 0; i < items.length; i += 1) {
			items[i].totalPrice = parseFloat(items[i].productPrice.slice(1)) * parseInt(items[i].quantity);

			total += items[i].totalPrice;
		}

		return {
			items: items,
			total: total,
			quotePricing: $.get('showPricing', false),
		};
	},

	/**
	 * Get total price of all items
	 *
	 * @private
	 */
	getTotalPrice: function() {
		var items = this.app.$get('items'),
			totalPrice = 0;

		for (var i = 0; i < items.length; i += 1) {
			totalPrice += (parseFloat(items[i].productPrice.slice(1)) * parseInt(items[i].quantity));
		}

		return totalPrice.toFixed(2);
	},

	/**
	 * Remove item from session storage and data store
	 *
	 * @private
	 */
	removeItem: function(el) {
		var data = this.app.$get(),
			index = $(el).parents('ref:item').data('index'),
			itemCount = this.store.get('itemCount');

		data.items.splice(index, 1);

		this.syncItems('items', data.items);

		this.app.$resume(true);

		this.store.set('itemCount', itemCount - 1);

		this.updateCart();
		this.createCart();
		this.showEmptyCart();
	},

	/**
	 * Sync items in session storage and data store
	 *
	 * @private
	 */
	syncItems: function(key, data) {
		this.app.$set(key, data);
		this.store.set(key, data);
	},

	/**
	 * Show empty quote cart
	 *
	 * @private
	 */
	showEmptyCart: function() {
		if (this.store.get('itemCount') === 0) {
			$('ref:emptyCart').activate();
			$('ref:quoteSummary').disable();
			$('ref:quoteList').disable();
		}
	}
});